export default __webpack_public_path__ + "static/card-4-36c6104051cc43db0c2493e9c012f778.svg";